import axios from '../../../api/axiosSetup3';
import packageJson from '../../../../package.json';

export interface Balance {
    value: number;
    crn: string;
    startDate?: Date;
    endDate?: Date;
}

export interface BasePrice {
    crn: string;
    value: number;
}

export interface CameraCatg {
    type: string;
    coeff: number;
}

export interface DiscountPrepayment {
    id: number;
    from: number;
    to: number;
    value_pc: number;
}

export interface DiscountQuantity {
    id: number;
    from: number;
    to: number;
    value_pc: number;
}

export interface LprOrder {
    customer_id: number;
    analytics_type: number;
    order_count: number;
    datasource: number;
}

const balanceKeyMap: Record<keyof Balance, string> = {
    value: "value",
    crn: "crn",
    startDate: "start_date",
    endDate: "end_date",
};

const getBalance = async (): Promise<Balance | null> => {
    const res = await axios.get('/balance', {
        headers: {
            'Accept-Profile': 'billing' // schema
        }        
    });
    if (res.data && res.data.length > 0) {
        return {
            value: res.data[0].value,
            crn: res.data[0].crn,
            startDate: new Date(res.data[0].start_date),
            endDate: new Date(res.data[0].end_date),
        };
    } else {
        return null;
    }
}

const getSubscription__  = async (customer_id: number): Promise<boolean> => {
    const res = await axios.get(`/get_subscription/?customer_id=${customer_id}`, {
        headers: {
            'Accept-Profile': 'billing' // schema
        }        
    });
    if (res.data && res.data.length > 0) {
        return true;
    } else {
        return false;
    }
}

const getSubscription  = async (customer_id: number): Promise<boolean> => {
    const res = await axios.get(`https://avto.aipeeper.com/api/billing/get_subscription/?customer_id=${customer_id}`);
    return (res.data?.subscription_state || 'n/d') == 'active';
    
    // return !!res.data;
    
    // if (res.data && res.data.length > 0) {
    //     return true;
    // } else {
    //     return false;
    // }
}

const printOrder = async (orderId: number): Promise<any> =>  {
    try {
        const res = await axios.get(`/rpc/print_order?order_id_inp=${orderId}`, {
            headers: {
                'Accept': 'application/pdf',
                'Accept-Profile': 'billing', // schema
            },
            responseType: 'blob',
        });
        return res.data;
    } catch {
        return null;
    }
}

const createOrder = async (amount: number, currency: string, description: string, param: any,
    // userId: number, tenantId: string, mode: string,
    method: string,
): Promise<any> => {
    try {
        // const res = await axios.post('/rpc/create_liqpay_order', {
        //     amount_inp: amount,
        //     currency_inp: currency,
        //     description_inp: description,
        //     app_id_inp: packageJson.name,
        //     param_inp: param,
        //     tenant_id_inp: tenantId,
        //     user_id_inp: userId,
        //     mode_inp: mode,
        // }, {
        //     headers: {
        //         // 'Accept-Profile': 'billing', // schema
        //         'Content-Profile': 'billing' // schema
        //     }        
        // });
        const res = await axios.post('/rpc/create_order', {
            amount_inp: amount,
            currency_inp: currency,
            description_inp: description,
            app_id_inp: packageJson.name,
            param_inp: param,
            pay_type: method
        }, {
            headers: {
                'Content-Profile': 'billing' // schema
            }        
        });
        return res.data ? res.data : null;
    } catch {
        return null;
    }
}

const getOrderStatus = async (orderId: string): Promise<any> => {
    try {
        /*
        const res = await axios.get(`/pay_status?order_id=eq.${orderId}`, {
            headers: {
                'Accept-Profile': 'billing' // schema
            }        
        });
        */
        const res = await axios.get(`https://avto.aipeeper.com/api/billing/pay_status/?order_id=${orderId}`);
        return res.data ? res.data : null;
    } catch {
        return null;
    }
}

const getBasePrice = async (): Promise<BasePrice[]> => {
    const res = await axios.get('/subscription_base_price', {
            headers: {
                // 'Accept-Profile': 'billing' // schema
            }        
        });
    return res.data ? res.data : [];
}

// const getCameraCatg = async (): Promise<CameraCatg[]> => {
//     // const res = await axios.get('https://cnt.theweb.place/api/billing/camera_catg/');
//     const res = await axios.get(basename + '/api/billing/camera_catg/');
//     return res.data ? res.data : [];
// }

const getCameraTotalCount = async (): Promise<number> => {
    const res = await axios.get('/lpr_origin', {
        headers: {
            Prefer: 'count=exact',
        },
    }); 
    // return res.data;
    return parseInt(res.headers['content-range'].split('/')[1]);
}

const getCameraActiveCount = async (): Promise<number> => {
    const res = await axios.get('/lpr_origin?is_enabled=eq.true', {
        headers: {
            Prefer: 'count=exact',
        },
    }); 
    // return res.data;
    return parseInt(res.headers['content-range'].split('/')[1]);
}

const getDiscountPrepaiment = async (): Promise<DiscountPrepayment[]> => {
    const res = await axios.get('/discount_prepaiment'); 
    return res.data;
}

const getDiscountQuantity = async (): Promise<DiscountQuantity[]> => {
    const res = await axios.get('/discount_quantity'); 
    return res.data;
}

// mock function
const calcEndDate = async (
        p_customer_id: number, 
        camera_cnt: number, ): Promise<Date> => {
    const res = await axios.post('/rpc/lpr_get_new_billing_ts', {
            p_customer_id: p_customer_id, 
            camera_cnt: camera_cnt,
        }, {
        headers: {
            'Content-Profile': 'billing', // schema
        }
    }); 
    return new Date(res.data);
}

const changeOrder = async (
        customer_id: number,
        order_count: number,        
        end_date: Date): Promise<boolean> => {
    try {
        const res = await axios.post('/rpc/sf_change_order', {
            customer_id,
            order_count,
            end_date,
        }); 
        return res.status === 204;
    } catch (err) {
        console.error('[Balance API] Error during changeOrder:', err);
        return false;
    }
}

const getLprOrder = async (): Promise<LprOrder[]> => {
    const res = await axios.get('/lpr_order'); 
    return res.data;
}

const cancelService_ = async (customer_id: number): Promise<boolean> => {
    try {
        const res = await axios.patch('/lpr_origin', {
            customer_id, 
            is_enabled: false}); 
        return res.status === 204;
    } catch (err) {
        console.error('[Balance API] Error during cancelService:', err);
        return false;
    }
}

const suspendService__ = async (customer_id: number): Promise<boolean> => {
    try {
        const res = await axios.post('/rpc/sf_suspend_service', {customer_id}); 
        return res.status === 204;
    } catch (err) {
        console.error('[Balance API] Error during cancelService:', err);
        return false;
    }
}

const suspendService = async (customer_id: number): Promise<boolean> => {
    try {
        const res = await axios.get(`https://avto.aipeeper.com/api/billing/unsubscribe/?customer_id=${customer_id}`); 
        return res.status === 200;
    } catch (err) {
        console.error('[Balance API] Error during cancelService:', err);
        return false;
    }
}

export const api = {
    getBalance,
    createOrder,
    printOrder,
    getOrderStatus,
    getBasePrice,
    getCameraTotalCount,
    getCameraActiveCount,
    getDiscountPrepaiment,
    getDiscountQuantity,
    getLprOrder,
    changeOrder,
    suspendService,
    getSubscription,
    calcEndDate,
}